module.exports = __webpack_public_path__ + "img/BobbyZ.a8e1157a.jpg";